import React, { FC } from 'react';
import { Text, TextTypography } from '../Text/Text';
import { makeStyles } from '@material-ui/core/styles';

export interface UserInfoProps {
    // Optional
    className?: string;
    children?: any;
}

const useStyles = makeStyles(theme => ({
    border: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(2),
        borderRadius: 10,
        backgroundColor: theme.palette.fixedActive.main,
        minHeight: 48,
    },
}));

export const UserInfo: FC<UserInfoProps> = props => {
    const classes = useStyles();
    const { className } = props;
    return (
        <div className={className}>
            <div className={classes.border}>
                <Text typography={TextTypography.CAPTION_ACCENT}>{props.children}</Text>
            </div>
        </div>
    );
};
